<template>
  <el-form label-position="top" label-width="80px">
    <el-form-item label="搜索">
      <el-input size="mini" style="width:220px;top:2px;" placeholder="姓名或手机号码" v-model="form.key" clearable></el-input>
    </el-form-item>
    <el-form-item label="创建时间">
      <el-date-picker v-model="form.dateRange1" type="daterange" size="mini" range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOption"
        value-format="yyyy-MM-dd"></el-date-picker>
    </el-form-item>
    <el-form-item label="订单状态">
      <el-select size="mini" style="width:180px;" multiple v-model="form.blindOrderStatus">
        <el-option v-for="[value, label] in blindOrderStatusMap" :key="value" :label="label" :value="value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="客户经理">
      <el-select size="mini" style="width:180px;" multiple v-model="form.member">
        <el-option v-for="item in members" :key="item.memberId" :label="item.userName" :value="item.memberId">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="退订状态">
      <el-select size="mini" style="width:180px;" multiple v-model="form.refundStatus">
        <el-option v-for="[value, label] in refundStatusMap" :key="value" :label="label" :value="value"></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>
<script>
import { refundStatusMap, blindOrderStatusMap, datePickerOption } from '../constants.js'

// import { deepClone } from '@/assets/js/util'

export default {
  name: 'BlindSearchForm',
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
  },
  model: {
    prop: "form",
    event: "change"
  },
  data() {
    return {
      dealer: this.$common.getLoginInfo().profile,
      refundStatusMap,
      blindOrderStatusMap,
      datePickerOption,
      blindOrderStatusDics: [], // 盲订订单状态
      members: [], // 客户经理
    }
  },
   created() {
    const baseInfo = this.$common.getBaseInfo();
    // this.blindOrderStatusDics = baseInfo.blindOrderStatusDics;
    this.retrieveMembers();
  },
  computed: {
    // baseInfo() {
    //   return this.$common.getBaseInfo()
    // },

  },
  mounted() {
  },
  methods: {
    retrieveMembers() {
      this.$httpAuth;
      this.$httpAuth
        .post("/v1/dealerMemberRpc/managerMembers", {
          dealerId: this.dealer.dealerId,
        })
        .then((response) => {
          this.members = response.data.data;
        });
    },
  }
}
</script>
<style scoped>
::v-deep .el-form-item {
  margin-bottom: 5px;
}

::v-deep .el-form-item .el-form-item__label {
  line-height: 16px;
  padding-bottom: 3px;
}

/* ::v-deep .date-box {
  display: flex;
}
.date-box ::v-deep .el-date-editor--data.el-input {
  width: 160px;
}
.date-box ::v-deep .el-date-editor--time-select.el-input {
  width: 140px;
}
.date-box ::v-deep .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding-left: 26px;
  padding-right: 26px;
  font-size: 12px;
}
.date-box ::v-deep .el-input__icon {
  width: 14px;
  line-height: 28px;
} */
</style>